import { postEventStream } from "./eventStream";
import { saveBlob } from "./useCaseDiagramService";

// Process digital twin ("prototype"): the backend builds a ready-to-run React
// app of the process and returns it as a ZIP. The server allows 2 requests a
// minute, so only call this on a button click.

const MESSAGES = {
  403: "You do not have access to this process.",
  404: "Process not found.",
  429: "Too many requests. A digital twin can be created twice a minute. Wait a minute and try again.",
};

export function prototypeErrorMessage(error) {
  // 400 carries the reason (no tasks, decisions or sub-processes yet).
  if (error?.status === 400 && error.message) return error.message;
  return MESSAGES[error?.status] || "Something went wrong. Please try again.";
}

// POST /process/:id/prototype/stream?ai=true|false&storiesAi=true|false
// Events, in order: `status` as each phase starts, `file` as each project file
// is ready, `screen` as the AI finishes each task (only with ai=true), and
// finally `done` (the ZIP) or `error`. `handlers` maps each event name to a
// callback taking its data.
//   ai: AI writes each task's scene, documents and work screen.
//   storiesAi: AI writes the user-story text first (adds about 2-3 minutes).
export function streamPrototype(
  processId,
  { ai = true, storiesAi = false, signal } = {},
  handlers,
) {
  if (!processId) throw new Error("Process ID is required");
  return postEventStream(
    `/process/${encodeURIComponent(processId)}/prototype/stream?ai=${
      ai ? "true" : "false"
    }&storiesAi=${storiesAi ? "true" : "false"}`,
    (event, data) => handlers[event]?.(data),
    { signal },
  );
}

// Save the ZIP carried (base64) by the `done` event.
export function saveTwinZip(done) {
  const binary = atob(done.zipBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  saveBlob(
    new Blob([bytes], { type: "application/zip" }),
    done.fileName || "digital-twin.zip",
  );
}
